export default "__VITE_ASSET__BaxVg1Nm__"